(() => {
  const rootSelector =
    '.vk-pdp-editorial-gallery.vk-pdp-gallery-indicator--progress:is(.vk-pdp-gallery-mobile--free-scroll, .vk-pdp-gallery-mobile--snap-slider)';
  const initializedRoots = new WeakSet();

  const initializeRoot = (root) => {
    if (initializedRoots.has(root)) return;

    const scroller = root.querySelector('.product__media-list');
    const progress = root.querySelector('.vk-pdp-gallery-progress');

    if (!scroller || !progress) return;

    initializedRoots.add(root);

    let animationFrame;

    const update = () => {
      animationFrame = undefined;

      const maxScroll = scroller.scrollWidth - scroller.clientWidth;
      const scrollPosition = Math.abs(scroller.scrollLeft);
      const value = maxScroll > 0 ? scrollPosition / maxScroll : 0;
      const normalizedValue = Math.min(1, Math.max(0, value));

      progress.style.setProperty('--vk-gallery-progress', normalizedValue.toString());
    };

    const scheduleUpdate = () => {
      if (animationFrame) return;
      animationFrame = requestAnimationFrame(update);
    };

    scroller.addEventListener('scroll', scheduleUpdate, { passive: true });
    window.addEventListener('resize', scheduleUpdate, { passive: true });

    new ResizeObserver(scheduleUpdate).observe(scroller);
    new MutationObserver(scheduleUpdate).observe(scroller, { childList: true });

    scheduleUpdate();
  };

  const initialize = (scope = document) => {
    if (scope.matches?.(rootSelector)) initializeRoot(scope);
    scope.querySelectorAll?.(rootSelector).forEach(initializeRoot);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
